import React from "react";
import { motion } from "@/lib/motion";

// Entrance animations run on MOUNT (not scroll-gated) so content is always
// visible even if an IntersectionObserver doesn't fire (e.g. inside iframes).
export function Reveal({ children, delay = 0, y = 28, className = "" }) {
    return (
        <motion.div
            initial={{ opacity: 0, y }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
            className={className}
        >
            {children}
        </motion.div>
    );
}

export function Stagger({ children, className = "" }) {
    return (
        <motion.div
            className={className}
            initial="hidden"
            animate="show"
            variants={{ show: { transition: { staggerChildren: 0.06 } } }}
        >
            {children}
        </motion.div>
    );
}

export const staggerItem = {
    hidden: { opacity: 0, y: 24 },
    show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] } },
};
